module.exports = "/build/web/svg/sponsor/adidas.3c6adeffae3f04a2e25993283732f38a.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/adidas.svg
// module id = 206
// module chunks = 24